<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Ky97TS/tc-custom/9781399084031.jpg?1709608613631" alt="This image is the cover for the book Roman King Arthur?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Roman King Arthur?
      </h1>
      <p class="bookDescription body article font2">
        <p>The 2004 film, King Arthur, starring Clive Owen and Keira Knightley, introduced the audience to Lucius Artorius Castus as the basis to the much later legend of King Arthur. The book analyses the theories behind the film which link this second to third century Roman officer with the medieval Arthurian legends and a possible historical figure in post-Roman Britain.  This first full academic study of Artorius Castus offers a number of potential timeframes and details his career through a turbulent and bloody period of Roman history, serving as primus pilus of V Macedonia and praefectus of the Sixth Legion in northern Britain.  Turning to the historical narrative of the film it covers the archaeological and literary evidence for the break down of Roman Britain, arrival of Germanic peoples and emergence of petty kingdoms and new cultural identities. The penultimate chapter lays out the evidence for and against a historical Arthur, offering suggestions as to his identity, location of his battles and the possible political, military, social and cultural situation he lived and fought in.  This is an entertaining and informative picture of two fascinating figures, one firmly historical, the other shrouded in myth and legend. The book leaves the reader with a clear picture of the lives of a Roman career officer and later dark-age warrior and the different worlds in which they lived.  Anyone interested in the Roman period, post-Roman Britain and the possibilities for a historical Arthur should enjoy this book.  “A fascinating investigation into the historical figure of Lucius Artorius Castus, camp prefect of VI Victrix based at Eboracum, York”. Dave Grainger, Legio VI Victrix, re-enactment group, York.  “A welcome addition to modern discussions the roman army officer Lucius Artorius Castus which seeks to place him within an appropriate timescale and very properly disputes the links that have been suggested between this ‘real’ Roman army officer and the later and very much more fictional king Arthur”. Professor Nick Higham, historian and author</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tony Sullivan
      </h2>
      
      <p class="authorDescription body article">Tony Sullivan lives in Kent with his wife and children. He spent 31 years in the London Fire Brigade and have recently retired. He has been interested in dark age history and King Arthur in particular for many years.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?13e6558e